import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import "./css/styles.css";
import axios from "axios";
import Cookies from "universal-cookie";
import { withRouter } from 'react-router-dom';

const RejectionAlert = ({ history}) => {
  
  const [rejection, setRejection] = useState({})
  const [open, setOpen] = useState(false)

  const getRejections=async()=>{
    const api_url = localStorage.getItem("api_url");
    const user_id = JSON.parse(localStorage.getItem("session_userid"))
    axios({
      method:"get",
      url:api_url+"get_rejections/"+user_id,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res)=>{
      const response = res.data
      if(response.status!=true){

      }else{
        setRejection(response)
        setOpen(true)
      }
    })
  }

  useEffect(()=>{
    getRejections()
  },[history.location.pathname])

  const handleOkay = () => {
    setOpen(false);
    if (rejection.attempt === 3) {
      logout();
    }
  };

  const logout = () => {
    const api = localStorage.getItem("api_url");
    var loginstatus = new FormData();
    loginstatus.set(
      "user_id",
      JSON.parse(localStorage.getItem("session_userid"))
    );
    loginstatus.set("status", "0");
    loginstatus.set("language", localStorage.getItem("LangValue"));
    axios({
      method: "post",
      url: api + "webonlinestatus",
      data: loginstatus,
    }).then((res) => {
      const status = res.data.status;
      if (status === "true") {
        const cookies = new Cookies();
        cookies.set("onboarded", "false", { path: "/" });
        cookies.set("signuptab", false);
        localStorage.setItem("session_token", JSON.stringify(null));
        localStorage.setItem("session_userid", JSON.stringify(null));
        history.push("/login");
        window.location.reload();
      }
    });
  };

  return (
    <>
    <Modal isOpen={open} className="premiumPopup vertically-center apd5 custom-modal">
      <div className="alert-box">
        <h3 className="heading-tertiary gutter-bottom small-mt">
          Dear User {rejection && rejection.username},
        </h3>

        <p className="paragraph">
          You have received a Rejection code by a user you attempted to connect
          with. The User doesn't want to be bothered by you.
        </p>

        <p className="paragraph small-mt">
          This User won't be available for you anymore.
        </p>

        <h3
          className={`heading-tertiary reject-attempt${rejection && rejection.attempt} small-mt gutter-bottom`}
        >
          Attempt #{rejection && rejection.attempt}
        </h3>

        <p className={`paragraph note gutter-bottom ${rejection && rejection.attempt==3?"attempt3":""}`}>
          <span>NOTE:</span> Unfortunately, you will be automatically blocked
          from the app after your third attempt.
        </p>
      </div>
      <button className="alert-button" onClick={handleOkay}>
        Okay
      </button>
    </Modal>
    </>
  );
};

export default withRouter(RejectionAlert);
